// extracted by mini-css-extract-plugin
export default {"track":"ScrollProgressBar_track__osHo9","bar":"ScrollProgressBar_bar__LPfuB"};